import { Box, Button, Typography } from "@mui/material";
import React from "react";
import SubHeader from "../../../../components/SubHeader";
import styles from "./style";
import theme from "../../../../theme/theme";
import StaffList from "./StaffList";
import { useNavigate } from "react-router-dom";

const ViewStaffPage = ({handleFilter}) => {
  const navigate = useNavigate()

  return(
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.leaveHeading}>Staff</Typography>
        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" onClick={() => navigate("/dashboard/addNewStaff")} color="success" sx={styles.checkinBtn}>
            {"+ Add Staff"}
          </Button>

        </Box>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader
          search={true}
          sortBy={true}
          onchange={(txt) => handleFilter(txt)}
          handleSort={(txt) => handleFilter("",txt)}
        />
        {<StaffList/>}


      </Box>
    </>
  )
}

export default ViewStaffPage